import axios, { AxiosResponse } from 'axios';
import { BaseService } from './BaseService';
import { ApplicationInfo } from './types/job';

export default class PostingService extends BaseService {
    constructor() {
        super('posting');
    }

    async getJobApplicationInfo(jobId: string): Promise<ApplicationInfo> {
        return axios({
            method: 'GET',
            url: this.getUrl(`${jobId}/application`, {}),
        }).then((res: AxiosResponse<ApplicationInfo>) => res.data);
    }
}
